(function () {
  'use strict';

  var form = document.getElementById('cc-inquiry-form');
  if (!form) return;

  var submitBtn = form.querySelector('[data-cc-submit]');
  var successEl = form.querySelector('[data-cc-status="success"]');
  var errorEl = form.querySelector('[data-cc-status="error"]');

  form.setAttribute('novalidate', 'novalidate');

  var requiredFields = Array.prototype.slice.call(form.querySelectorAll('[required]'));

  function fieldWrapper(el) {
    return el.closest('.cc-field');
  }

  function showFieldError(el, show) {
    var wrapper = fieldWrapper(el);
    var msgEl = form.querySelector('[data-cc-error="' + el.id + '"]');
    if (wrapper) wrapper.classList.toggle('cc-field--invalid', show);
    if (msgEl) msgEl.hidden = !show;
  }

  function isValid(el) {
    if (!el.value.trim()) return false;
    if (el.type === 'email') return el.checkValidity();
    return true;
  }

  requiredFields.forEach(function (el) {
    el.addEventListener('input', function () {
      if (isValid(el)) showFieldError(el, false);
    });
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (successEl) successEl.hidden = true;
    if (errorEl) errorEl.hidden = true;

    var firstInvalid = null;
    requiredFields.forEach(function (el) {
      var ok = isValid(el);
      showFieldError(el, !ok);
      if (!ok && !firstInvalid) firstInvalid = el;
    });

    if (firstInvalid) {
      firstInvalid.focus();
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var originalLabel = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
    }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (response.ok) {
          if (successEl) successEl.hidden = false;
          form.reset();
        } else {
          if (errorEl) errorEl.hidden = false;
        }
      })
      .catch(function () {
        if (errorEl) errorEl.hidden = false;
      })
      .then(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
        }
        if (successEl && !successEl.hidden) successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
  });
})();
